import type { MaterialSlot } from "@/api/schemas";

/**
 * Druh materiálu slotu — plošná doska alebo dĺžkový materiál (pracovná
 * doska, zástena). Sklo je plošné.
 */
export function druhSlotu(slot: MaterialSlot | null | undefined): "plosny" | "dlzkovy" {
  return slot?.material?.druh === "dlzkovy" ? "dlzkovy" : "plosny";
}

/**
 * Sloty, ktoré sa dielcu dajú ponúknuť (KOLO 226): rovnakého druhu ako
 * jeho doterajší slot. Import od KOLA 226 dáva do Materiálov aj pracovné
 * dosky a zásteny — bez filtra by sa doska 500 × 300 dala jedným klikom
 * prepnúť na pracovnú dosku a nacenila by sa na metre. Dielec bez slotu
 * vidí všetky (druh sa nedá odhadnúť).
 */
export function slotyPreDielec(
  sloty: MaterialSlot[],
  aktualny: MaterialSlot | null | undefined,
): MaterialSlot[] {
  if (!aktualny) return sloty;
  const druh = druhSlotu(aktualny);
  return sloty.filter((s) => druhSlotu(s) === druh);
}
